
        import * as module0 from './controllers/email_validation_controller.js';import * as module1 from './controllers/example_controller.js';import * as module2 from './controllers/pricing_toggle_controller.js'
        const modules = {
            "./controllers/email_validation_controller.js": module0,
            "./controllers/example_controller.js": module1,
            "./controllers/pricing_toggle_controller.js": module2,
        };
        export default modules;
      